import http from "../../../src/util/axios";
import Vue from 'vue';
import config from "../../../config/endpoints";

const PH_URL = config.ph_url;
export default {
  namespaced: true,
  state: {
    multiSlot: false,
    tagList: [],
    indicationList: [],
    medList: [],
    medreqList: [],
    categoryList: [],
    packageList: [],
    customList:[],
    testList: [],
    medicineList: [],
    labTech: null,
    taskList: []
  },
  mutations: {
    SET_MULTISLOT: function(state,payload){
      state.multiSlot = payload
    },
    SET_TAGLIST: function(state,payload){
        state.tagList = payload
    },
    SET_CATEGORYLIST: function(state,payload){
      state.categoryList = payload
   },
    SET_PACKAGELIST: function(state,payload){
        state.packageList = payload
    },
    SET_MEDLIST: function(state,payload){
      state.medicineList = payload
  },
    SET_CUSTOMLIST:function(state,payload){
      state.customList = payload
  },
    SET_TESTLIST: function(state,payload){
      state.testList = payload
   },
   SET_INDICATIONS: function(state,payload){
      state.indicationList = payload
    },
    SET_MEDDETAILS: function(state,payload){
      state.medList = payload.display
      state.medreqList = payload.redList
    },
    UPDATE_PACKAGELIST_COUNT: function(state,payload){
      const { pack,count } = payload
      const selectedPack = state.packageList.find((p) => p.pkg_id == pack.pkg_id)
      selectedPack["count"] = count
    },
    UPDATE_MEDLIST_COUNT: function(state,payload){
      const { med,count } = payload
      const selectedMed = state.medicineList.find((m) => m.id == med.id)
      selectedMed["count"] = count
    },
    UPDATE_CUSTOM_COUNT: function(state,payload){
      const { custom,count } = payload;
         const selectedCustom = state.customList.find((tsk) => tsk.id == custom.id);
         const findIndex = state.customList.findIndex(a => a.id === custom.id)
         selectedCustom["count"] = count;
         Vue.set(state.customList, findIndex , selectedCustom)
    },
    UPDATE_TESTLIST_COUNT: function(state,payload){
      const { tests,count } = payload
      const selectedTests = state.testList.find((t) => t.tst_id == tests.tst_id)
      selectedTests["count"] = count
    },
    SET_LABTECH_DETAILS: function(state,payload){
      state.labTech = payload
    },
    SET_TASKLIST: function(state, payload){
      state.taskList = payload
     },
     UPDATE_TASKLIST_COUNT: function(state, payload){
      const { tasks, count } = payload
      const selectedTasks = state.taskList.find((p) => p.tsk_id == tasks.tsk_id)
      selectedTasks["count"] = count;
    },
  
  },
  actions: {
    UPDATE_MEDLIST_COUNT({commit}, payload) {
      commit('UPDATE_MEDLIST_COUNT', payload)
    },
    UPDATE_PACKAGELIST_COUNT({commit}, payload) {
      commit('UPDATE_PACKAGELIST_COUNT', payload)
    },
    UPDATE_TESTLIST_COUNT({commit}, payload) {
      commit('UPDATE_TESTLIST_COUNT', payload)
    },
    UPDATE_CUSTOM_COUNT({commit}, payload) {
      commit('UPDATE_CUSTOM_COUNT', payload)
    },
    UPDATE_TASKLIST_COUNT({commit}, payload) {
      commit('UPDATE_TASKLIST_COUNT', payload)
    },
  },
  getters: {
    getMultislotValue: state => state.multiSlot || false,
    tagList: state => state.tagList || [],
    getIndicationList: state => state.indicationList || [],
    getMedList: state => state.medList || [],
    getMedReqList: state => state.medreqList || [],
    categoryList: state => state.categoryList || [],
    packageList: state => state.packageList || [],
    testList: state => state.testList || [],
    customList: state => state.customList || [],
    labTechDetails: state => state.labTech || null,
    selectedPackageList: state => state.packageList.filter(_=> _.count > 0) || [],
    selectedTestList: state => state.testList.filter(_=> _.count > 0) || [],
    selectedCustomList: state => state.customList.filter(_=> _.count > 0) || [],
    selectedMedicineList: state => state.medicineList.filter(_=> _.count > 0) || [],
    medicineList: state => state.medicineList || [],
    taskList: state => state.taskList || [],
    selectedTaskList: state => state.taskList.filter(_=> _.count > 0) || [],
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/browse.js